// HUB RH (reescrito em 2026-08-25): uma vista única, pessoa-cêntrica.
//
// As duas abas antigas (Profissionais / Documentos) viraram a EquipeRH: uma
// tabela por pessoa que abre a FichaProfissional (?pessoa=<uuid>). Não há mais
// HubAbas aqui, e o ?aba= legado (links salvos de "?aba=profissionais" /
// "?aba=documentos") é IGNORADO de propósito — as duas abas apontavam para
// conteúdos que hoje moram na mesma tela, então qualquer valor de ?aba= cai no
// lugar certo sem redirect.
//
// Permissões: o gate por action continua no backend (rh_equipe/rh_resumo
// exigem administrativo.rh.documentos.ver; salário segue o gate financeiro) —
// a EquipeRH degrada bloco a bloco em vez de esconder a tela.
import { ReactElement } from 'react';
import EquipeRH from './EquipeRH';

export default function AdministrativoRHHub(): ReactElement {
  return <EquipeRH />;
}
